import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-12 text-center" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = {
  key: 0,
  class: "col-12"
}
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = {
  key: 1,
  class: "col-12"
}
const _hoisted_8 = {
  key: 2,
  class: "col-12"
}
const _hoisted_9 = {
  key: 3,
  class: "col-12"
}
const _hoisted_10 = {
  key: 4,
  class: "col-12"
}
const _hoisted_11 = {
  key: 5,
  class: "col-12"
}
const _hoisted_12 = {
  key: 0,
  class: "row justify-content-center"
}
const _hoisted_13 = { class: "col-12" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 1,
  class: "text-center"
}
const _hoisted_19 = { class: "progress-spinner progress-spinner-active size-sm" }
const _hoisted_20 = { class: "visually-hidden" }
const _hoisted_21 = { class: "col" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  key: 1,
  class: "text-center"
}
const _hoisted_25 = { class: "progress-spinner progress-spinner-active size-sm" }
const _hoisted_26 = { class: "visually-hidden" }
const _hoisted_27 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_28 = { class: "modal-content" }
const _hoisted_29 = { class: "modal-header" }
const _hoisted_30 = {
  class: "modal-title h5 no_toc",
  id: "confirmDeleteModalLabel"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Chiudi finestra modale"
}, null, -1)
const _hoisted_32 = { class: "modal-body" }
const _hoisted_33 = { class: "modal-footer" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = ["disabled"]
const _hoisted_36 = { key: 0 }
const _hoisted_37 = {
  key: 1,
  class: "text-center"
}
const _hoisted_38 = { class: "progress-spinner progress-spinner-active size-sm" }
const _hoisted_39 = { class: "visually-hidden" }

import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "../../models/Store/store";
import api from "@/services/BookingService";
import _ from "lodash";
import Utils from "../../models/Utils/utils";
import { useI18n } from "vue-i18n";
import { useWidget } from "@/composables/useWidget";
import { useTenantConfig } from "@/composables/useTenantConfig";
import { RegistrationConfigItem, TenantBookingConfiguration } from "@/models/Configuration/TenantBookingConfiguration";
import moment from "moment";
import { Modal } from "bootstrap-italia";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditBookResumeData',
  setup(__props) {

const router = useRouter();
const store = useStore();
const { t } = useI18n();
const { rootElement } = useWidget();
const { hasConfiguration, getRouteNameServiceSelection } = useTenantConfig();

const loading = ref(false);
const isDeletingBooking = ref(false);

const nameVisibility = ref(true);
const lastNameVisibility = ref(true);
const mobilePhoneVisibility = ref(true);
const emailVisibility = ref(true);
const taxCodeVisibility = ref(true);
const userCodeVisibility = ref(false);

const error = ref(false);
const errorMessage = ref(t("messages.errorBookingDelete"));

const spacing = ref(t("settings.spacing"));

const confirmDeleteRef = ref(null);
let confirmDeleteModal: any;

const attentionTitle = computed(() => {
  return t("common.attention");
});

onMounted(() => {
  const localeCode = t("settings.localeCode");
  moment.locale(localeCode);

  confirmDeleteModal = new Modal(confirmDeleteRef.value, {
    backdrop: "static",
  });
  manageFieldsVisibility();
});

const manageFieldsVisibility = () => {
  if (hasConfiguration.value) {
    const tenantConfigs = Utils.getGenericConfig(
      store.tenantConfig.configurations.tenant
    ) as TenantBookingConfiguration;

    if (
      _.isNull(tenantConfigs) === false &&
      _.isUndefined(tenantConfigs) === false
    ) {
      let settings = tenantConfigs.registrationWebsettings.value as string;
      let settingsModel = JSON.parse(settings) as RegistrationConfigItem[];
      let settingModelCustom = settingsModel.find(c => c.key === "DEFAULT");

      nameVisibility.value = settingModelCustom.fields.find(c => c.key === "firstname").showed;
      lastNameVisibility.value = settingModelCustom.fields.find(c => c.key === "lastname").showed;
      mobilePhoneVisibility.value = settingModelCustom.fields.find(c => c.key === "mobilephone").showed;
      emailVisibility.value = settingModelCustom.fields.find(c => c.key === "email").showed;
      taxCodeVisibility.value = settingModelCustom.fields.find(c => c.key === "cf").showed;
    }
  }
};

const bookToEdit = computed(() => {
  return store.bookedit;
});

const bookingDateTime = computed(() => {
  return moment(store.bookedit.fromDate).format(t("settings.dateTimeUIFormat"));
});

const confirmDeleteMessage = computed(() => {
  return t("messages.confirmCancelBooking").replace(
    "##bookingCode##",
    bookToEdit.value.friendlyCode
  );
});

const categoriesFromBooking = computed(() => {
  if (bookToEdit.value.slots.length == 1) return null;
  const categoriesArray = bookToEdit.value.slots.map((item) => {
    return item.service.categoryName;
  });

  const categories = _.uniq(categoriesArray);
  return categories.join(", ");
});

const serviceFromBooking = computed(() => {
  const servicesArray = bookToEdit.value.slots.map((item) => {
    return item.service.name;
  });

  const services = _.uniq(servicesArray);

  return services.join(", ");
});

const documentsFromBooking = computed(() => {
  const documents: string[] = [];
  for (let index = 0; index < bookToEdit.value.slots.length; index++) {
    const item = bookToEdit.value.slots[index];
    if (item.service.serviceInfo) {
      var docs = item.service.serviceInfo.split("|");

      for (var j = 0; j < docs.length; j++) {
        if (
          documents.some(function (item) {
            return item == docs[j];
          }) == false
        ) {
          documents.push(docs[j]);
        }
      }
    }
  }
  return documents;
});

const openConfirmDeleteDialog = () => {
  confirmDeleteModal.show();
};

const closeConfirmDeleteDialog = () => {
  confirmDeleteModal.hide();
};

const deleteBooking = (source: string) => {
  api
    .deleteBooking(bookToEdit.value.code, bookToEdit.value.keyCode, source)
    .then((res) => {
      if (res) {
        router.push({ name: "deleted" });
      }
    })
    .catch((err) => {
      if (err && err.response) {
        if (err.response.status === 500) {
          if (err.response.data && err.response.data.errorMessage) {
            errorMessage.value = err.response.data.errorMessage;
          }
        }
      }
      error.value = true;
      console.log(err);
    })
    .finally(() => {
      isDeletingBooking.value = false;
      closeConfirmDeleteDialog();
    });
};

const editBooking = () => {
  loading.value = true;
  if (bookToEdit.value.slots.length > 1) {
    router.push({ name: "probook" });
  } else {
    const serviceRouteSelection = getRouteNameServiceSelection();
    router.push({ name: serviceRouteSelection });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", null, _toDisplayString(_unref(t)("common.bookingData")), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", null, [
          _createElementVNode("b", null, _toDisplayString(_unref(t)("common.bookingCode")) + ":", 1),
          _createElementVNode("span", null, _toDisplayString(spacing.value) + _toDisplayString(bookToEdit.value.friendlyCode), 1)
        ])
      ]),
      (categoriesFromBooking.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("label", null, [
              _createElementVNode("b", null, _toDisplayString(_unref(t)("common.categories")) + ":", 1),
              _createTextVNode(_toDisplayString(spacing.value) + _toDisplayString(categoriesFromBooking.value), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("label", null, [
          _createElementVNode("b", null, _toDisplayString(_unref(t)("common.location")) + ":", 1),
          _createTextVNode(_toDisplayString(spacing.value) + _toDisplayString(bookToEdit.value.room.location.name) + " - " + _toDisplayString(bookToEdit.value.room.name), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("label", null, [
          _createElementVNode("b", null, _toDisplayString(_unref(t)("common.booking")) + ":", 1),
          _createTextVNode(_toDisplayString(spacing.value) + _toDisplayString(bookingDateTime.value), 1)
        ])
      ]),
      (nameVisibility.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("label", null, [
              _createElementVNode("b", null, _toDisplayString(_unref(t)("common.firstName")) + ":", 1),
              _createTextVNode(_toDisplayString(spacing.value) + _toDisplayString(bookToEdit.value.firstName), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (lastNameVisibility.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("label", null, [
              _createElementVNode("b", null, _toDisplayString(_unref(t)("common.lastName")) + ":", 1),
              _createTextVNode(_toDisplayString(spacing.value) + _toDisplayString(bookToEdit.value.lastName), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (lastNameVisibility.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("label", null, [
              _createElementVNode("b", null, _toDisplayString(_unref(t)("common.taxCode")) + ":", 1),
              _createTextVNode(_toDisplayString(spacing.value) + _toDisplayString(bookToEdit.value.taxCode), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (mobilePhoneVisibility.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("label", null, [
              _createElementVNode("b", null, _toDisplayString(_unref(t)("common.phoneNumber")) + ":", 1),
              _createTextVNode(_toDisplayString(spacing.value) + _toDisplayString(bookToEdit.value.mobilePhone), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (emailVisibility.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("label", null, [
              _createElementVNode("b", null, _toDisplayString(_unref(t)("common.emailAddress")) + ":", 1),
              _createTextVNode(_toDisplayString(spacing.value) + _toDisplayString(bookToEdit.value.email), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("label", null, _toDisplayString(errorMessage.value), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary btn-lg my-3",
          onClick: editBooking,
          disabled: loading.value
        }, [
          (!loading.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_unref(t)("common.editBooking")), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(t)("common.loadingText")), 1)
                ])
              ]))
        ], 8, _hoisted_16)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-danger btn-lg my-3",
          onClick: openConfirmDeleteDialog,
          disabled: isDeletingBooking.value
        }, [
          (!isDeletingBooking.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_unref(t)("common.deleteBooking")), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(t)("common.loadingText")), 1)
                ])
              ]))
        ], 8, _hoisted_22)
      ])
    ]),
    _createElementVNode("div", {
      ref_key: "confirmDeleteRef",
      ref: confirmDeleteRef,
      class: "modal",
      tabindex: "-1",
      role: "dialog",
      "aria-labelledby": "confirmDeleteModalLabel",
      "aria-hidden": "true",
      "data-bs-backdrop": "static",
      "data-bs-keyboard": "false"
    }, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("h2", _hoisted_30, _toDisplayString(attentionTitle.value), 1),
            _hoisted_31
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("p", null, _toDisplayString(confirmDeleteMessage.value), 1)
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-primary btn-sm",
              onClick: closeConfirmDeleteDialog,
              disabled: isDeletingBooking.value
            }, _toDisplayString(_unref(t)("common.cancel")), 9, _hoisted_34),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary btn-sm",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteBooking('web'))),
              disabled: isDeletingBooking.value
            }, [
              (!isDeletingBooking.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_unref(t)("common.confirm")), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("span", _hoisted_39, _toDisplayString(_unref(t)("common.loadingText")), 1)
                    ])
                  ]))
            ], 8, _hoisted_35)
          ])
        ])
      ])
    ], 512)
  ], 64))
}
}

})